export default "__VITE_ASSET__1KJOs4ht__"